import { Card } from "react-bootstrap";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import "./styles.css";
import { useEffect } from "react";
import { local, session } from "../../../../services/storage.service";

const DocumentoAssinadoSucesso = () => {
	useEffect(() => {
		const cleanSession = () => {
			setTimeout(() => {
				session.clear();
				local.clear();
			}, 2500);
		};

		cleanSession();
	}, []);

	return (
		<>
			<Card className="aso-doc-card">
				<Card.Body className="aso-doc-card-body">
					<AssignmentTurnedInIcon
						sx={{
							fill: "#127902",
							width: "150px",
							height: "150px",
							marginBottom: "20px",
						}}
					/>
					<Card.Title className="aso-doc-cardTitle text-center">
						Documento assinado com sucesso!
					</Card.Title>
					<Card.Text className="aso-doc-cardSubTitle text-center">
						Agradecemos por fazer parte da Atento.
					</Card.Text>
					<Card.Text className="aso-doc-cardSubTitle text-center">
						Em caso de dúvidas, entre em contato com nosso suporte pelo telefone
						(41) 99777-3357.
					</Card.Text>
				</Card.Body>
			</Card>
		</>
	);
};

export default DocumentoAssinadoSucesso;
